import { render, staticRenderFns } from "./FormResidentialAbout.vue?vue&type=template&id=51e4f733&lang=pug&"
import script from "./FormResidentialAbout.vue?vue&type=script&lang=js&"
export * from "./FormResidentialAbout.vue?vue&type=script&lang=js&"
import style0 from "./FormResidentialAbout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports